import { defineStore } from 'pinia'
import type { TinySliderInstance } from 'tiny-slider'

export const useUpperSliderStore = defineStore('upperSlider', {
  state: () => ({
    sliderInstance: null as TinySliderInstance | null
  }),

  actions: {
    setSliderInstance(instance: TinySliderInstance | null) {
      this.sliderInstance = instance
    },

    goNext() {
      if (this.sliderInstance) {
        this.sliderInstance.goTo('next')
      }
    },

    goPrev() {
      if (this.sliderInstance) {
        this.sliderInstance.goTo('prev')
      }
    },

    destroy() {
      if (this.sliderInstance) {
        this.sliderInstance.destroy()
        this.sliderInstance = null
      }
    }
  }
})
